<template>
  <v-app-bar
    app
    flat
    height="50"
    fixed
  >
    <v-row no-gutters class="align-center" style="z-index: 20 !important;">
    <v-col class="d-flex align-center" style="flex-grow: 1; height: 100%;">
        <v-btn
        v-if="showExpandButton"
        fab
        x-small
        class="mr-2"
        @click="expandMenu"
        >
        <v-icon small>mdi-dots-vertical</v-icon>
        </v-btn>

        <router-link to="/" class="d-flex align-center">
        <img
            :src="organizationLogo"
            :alt="user.OrganizationName"
            style="max-height: 28px; padding: 0 6px;"
            :class="showExpandButton ? '' : 'ml-2'"
        />
        </router-link>

        <div class="ml-2 pb-2 align-center">
        <base-multiselect
          :ref="contentTypesMultiselectKey"
          :placeholder="$t('SelectItem')"
          :items="userContentTypes"
          @on-selection-change="onContentTypeSelected"
            hide-details
            style="max-width: 100%;"
        />
        </div>
    </v-col>
    <v-col class="d-flex align-center justify-center" style="flex-grow: 1; max-width: 50%; height: 100%;">
      <div style="display: flex; align-items: center; width: 100%;">
        <v-text-field
          v-model="searchText"
          :placeholder="$t('Search')"
          :error-messages="searchErrors"
          color="primary"
          hide-details
          dense
          persistent-placeholder
          style="width: 100%;"
          @keydown.enter="searchDocuments"
        >
          <template v-slot:append-outer>
            <v-btn
              fab
              x-small
              :loading="searchLoading"
              @click="searchDocuments"
              class="mt-0"
            >
              <v-icon small>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-text-field>
       </div>
     </v-col>
    <v-col class="d-flex align-center justify-end" style="margin-left: auto; height: 100%;">
        <div style="display: flex; align-items: center;">
        <health-status-icon style="display: flex; align-items: center;" />

        <v-menu bottom left offset-y origin="top right" :key="notifications.length">
          <template v-slot:activator="{ attrs, on }">
            <v-btn class="ml-2" min-width="0" text small v-bind="attrs" v-on="on" style="height: auto;">
              <v-badge :color="notificationColor" overlap bordered>
                <template v-slot:badge>
                  <span>{{ notifications.length }}</span>
                </template>
                <v-icon small>mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list flat tile class="pa-0 ma-0">
            <UserAlerts :alerts="notifications" @on-alert-removed="getUserAlerts" />
          </v-list>
        </v-menu>

        <v-menu bottom left min-width="200" offset-y origin="top right">
          <template v-slot:activator="{ attrs, on }">
            <v-btn min-width="0" text small class="ml-2" v-bind="attrs" v-on="on" style="height: auto;">
              <span class="font-weight-medium">{{ currentUserName }}</span>
              <v-icon right small>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list flat nav>
            <v-list-item
            v-for="delegation in userDelegations"
            :key="delegation.id"
            @click.prevent="openModalConfirmPassword(delegation)"
            class="tile"
        >
            <v-list-item-title>
            {{ delegation.name }} {{ delegation.surName }} {{ delegation.leyenda }}
            </v-list-item-title>
            <v-icon right small>mdi-account</v-icon>
            </v-list-item>

            <v-list-item @click.prevent="editProfile" class="tile">
              <v-list-item-title v-text="$t('EditProfile')" />
            </v-list-item>

            <v-divider class="my-1" />
            <v-list-item @click.prevent="logout" class="tile">
              <v-list-item-title v-text="$t('Logout')" />
            </v-list-item>
          </v-list>
        </v-menu>
        </div>
    </v-col>
    </v-row>

    <UserModal :ref="profileModalKey" @on-item-saved="onProfileSaved" />
    <ConfirmPasswordModal :ref="confirmPasswordModalKey"
        @password-confirmed="selectDelegation"
        @saml-login="samlLogin"
        @entraid-login="entraidLogin"
        />
  </v-app-bar>
</template>

<script>
import UserModal from '@/components/administration/user/UserModal';
import SearchType from '@/ecm/variables/SearchType';
import UserAlerts from '@/components/core/UserAlerts';
import AlertService from '@/services/AlertService';
import Notification from '@/ecm/models/UserAlert';
import BrowserAlert from '@/ecm/common/BrowserAlert';
import AlertType from '@/ecm/variables/AlertType';
import HealthStatusIcon from '@/components/core/HealthStatusIcon';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { mapGetters } from 'vuex';
import ConfirmPasswordModal from '@/components/admin/ConfirmPasswordModal.vue';
import Utils from '@/ecm/common/Utils';
import * as signalR from '@microsoft/signalr';
import OrganizationService from '@/services/OrganizationService';
import UserService from '@/services/UserService';
import EntraIdService from '@/services/EntraIdService';

export default {
    name: 'AppCoreAppBar',
    components: {
        UserModal,
        UserAlerts,
        HealthStatusIcon,
        ConfirmPasswordModal
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    async mounted() {
        if (this.token) {
            await this.getOrganizationLogo();
            this.connectionLegacy = $.hubConnection(this.apiUrl);

            this.connectionLegacy.qs = { access_token: this.token };

            BrowserAlert.requestPermission();
            var notificationHub = this.connectionLegacy.createHubProxy('notificationHub');

            var self = this;
            notificationHub.on('notify', notifications => {
                const notificationBackup = this.notifications;
                this.notifications = notifications.map(function(dto) {
                    const notification = new Notification(
                        dto,
                        self.title(dto.Type),
                        self.description(dto.Type, dto.ContentTypeName)
                    );
                    return notification;
                });
                if (notificationBackup.length != 0) {
                    this.notifications.forEach(newArray => {
                        notificationBackup.forEach(backup => {
                            if (
                                newArray.type == backup.type &&
                                newArray.contentTypeIds.toString() ==
                                backup.contentTypeIds.toString() &&
                                Math.max(...backup.alertIds) < Math.max(...newArray.alertIds)
                            ) {
                                BrowserAlert.show(newArray);
                            }
                        });
                    });
                } else {
                    this.notifications.forEach(newArray => {
                        BrowserAlert.show(newArray);
                    });
                }
            });

            this.connectionLegacy.start();

            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(this.apiUrl + '/notifications', {
                    accessTokenFactory: () => this.token,
                })
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Information)
                .build();

            this.connection.on('Notify', (notifications) => {
                const notificationBackup = this.notifications;
                this.notifications = notifications.map(function(dto) {
                    const notification = new Notification(
                        dto,
                        self.title(dto.Type),
                        self.description(dto.Type, dto.ContentTypeName)
                    );
                    return notification;
                });
                if (notificationBackup.length != 0) {
                    this.notifications.forEach(newArray => {
                        notificationBackup.forEach(backup => {
                            if (
                                newArray.type == backup.type &&
                                newArray.contentTypeIds.toString() ==
                                backup.contentTypeIds.toString() &&
                                Math.max(...backup.alertIds) < Math.max(...newArray.alertIds)
                            ) {
                                BrowserAlert.show(newArray);
                            }
                        });
                    });
                } else {
                    this.notifications.forEach(newArray => {
                        BrowserAlert.show(newArray);
                    });
                }
            });

            try {
                await this.connection.start();
            } catch (error) {
                console.error('Error al conectar con SignalR:', error);
            }
        }
    },
    destroyed() {
        if (this.connectionLegacy) {
            this.connectionLegacy.stop();
            this.connectionLegacy = null;
        }
        if (this.connection) {
            this.connection.stop();
            this.connection = null;
        }
    },
    data: () => ({
        connection: null,
        connectionLegacy: null,
        searchText: '',
        searchLoading: false,
        profileModalKey: 'profileModal',
        notifications: [],
        contentTypesMultiselectKey: 'ctSearchMultiselectKey',
        selectedContentTypes: [],
        confirmPasswordModalKey: 'confirmPasswordModalKey',
        selectedUserDelegation: null,
        organizationLogoUrl: null,
    }),
    mixins: [validationMixin],
    validations: {
        searchText: { required }
    },
    created() {
        this.getUserAlerts();
        this.$v.$reset();
    },
    computed: {
        ...mapGetters({
            user: 'account/user',
            apiUrl: 'account/apiUrl',
            token: 'account/token',
            userContentTypes: 'account/userContentTypes',
            userDelegations: 'account/userDelegations'
        }),
        isAdmin() {
            return this.user && (this.user.IsAdmin || this.user.SysLevel == 2);
        },
        currentUserName() {
            return this.user.Surname + ',' + this.user.Name;
        },
        showExpandButton() {
            return this.$vuetify.breakpoint.mobile;
        },
        searchErrors() {
            const errors = [];
            if (!this.$v.searchText.$dirty) return errors;
            !this.$v.searchText.required && errors.push(this.$t('RequiredField'));
            return errors;
        },
        profileModal() {
            return this.$refs[this.profileModalKey];
        },
        userCultureCode() {
            if (this.user) {
                return this.user.CultureCode;
            } else {
                return 'en';
            }
        },
        organizationLogo() {
            return this.organizationLogoUrl;
        },
        notificationColor() {
            return this.notifications.length > 0 ? 'red' : 'primary';
        },
        confimPasswordModalInstance() {
            return this.$refs[this.confirmPasswordModalKey];
        },
    },
    watch: {
        userCultureCode: {
            immediate: true,
            handler(val) {
                this.$vuetify.lang.current = val;
            }
        },
        $route(to, from) {
            if (to.name != 'Search') {
                this.searchText = '';
            }
        }
    },

    methods: {
        onContentTypeSelected(contentTypeIDs) {
            this.selectedContentTypes = contentTypeIDs;
        },
        async getOrganizationLogo() {
            if (this.user.IsAdmin) {
                this.organizationLogoUrl = '/static/logo2.png';
            } else {
                this.organizationLogoUrl = await OrganizationService.getLogo(this.user.OrganizationID);
            }
        },
        searchDocuments() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.$v.$reset();
            this.searchLoading = true;

            var pattern = {
                contentTypeIDs: this.selectedContentTypes.join(),
                searchPattern: this.searchText
            };

            var route = `/search/${SearchType.FullText}/${encodeURIComponent(
                JSON.stringify(pattern)
            )}`;

            this.$router.push(route);
            // this.searchText = "";
            this.searchLoading = false;
        },
        editProfile() {
            this.profileModal.edit(this.user);
        },
        onProfileSaved() {
            Promise.all([
                this.$store.dispatch('account/getUser')
                    .then(() => {
                        this.$store.dispatch('account/postCulture');
                        return this.$store.dispatch('account/getLocalization');
                    }),
                this.$store.dispatch('account/getUserMenu'),
                this.$store.dispatch('account/getOperators'),
                this.$store.dispatch('account/getStandardFields'),
            ]).finally(() => {
                location.reload();
            });
        },
        logout() {
            const user = window.getApp.$store.getters['account/user'];
            const organizationHasSamlSettings = localStorage.getItem('organizationHasSamlSettings');
            window.getApp.$emit('APP_LOGOUT', null, (organizationHasSamlSettings != null && organizationHasSamlSettings === 'true') ? user.OrganizationID : null);
        },
        expandMenu() {
            this.$store.dispatch('theme/setDrawer', true);
        },
        getUserAlerts() {
            if (this.token) {
                AlertService.getUserAlerts().then(data => {
                    this.notifications = data.map(function(dto) {
                        return new Notification(dto);
                    });
                });
            }
        },
        title(alert) {
            switch (alert) {
            case AlertType.ContentType:
                return `${this.$t('ContentTypeAlert')}`;
            case AlertType.UserGenerated:
                return `${this.$t('UserAlert')}`;
            case AlertType.FlowStateChange:
            case AlertType.FlowStateExpired:
                return `${this.$t('FlowAlert')}`;
            case AlertType.FlowDistribution:
                return `${this.$t('Site.Distributions.DistributionAlert')}`;
            }
        },
        description(alert, description) {
            switch (alert) {
            case AlertType.ContentType:
                return `${this.$t('AlertContentTypeDescription')}: ${description}`;
            case AlertType.UserGenerated:
                return `${this.$t('AlertUserGeneratedDescription')}: ${description}`;
            case AlertType.FlowStateChange:
                return `${this.$t('AlertStateChangeDescription')}: ${description}`;
            case AlertType.FlowStateExpired:
                return `${this.$t('AlertStateExpiredDescription')}: ${description}`;
            }
        },
        selectDelegation(password) {
            this.$store
                .dispatch('account/login', {
                    username: this.$store.getters['account/user'].Login,
                    password: password,
                    impersonated_user_login: this.selectedUserDelegation.login,
                })
                .then((resp) => {
                    this.confimPasswordModalInstance.loading = false;
                    this.confimPasswordModalInstance.hide();
                    window.getApp.$emit('APP_LOGIN_SUCCESS');
                    this.$router.push('/');
                    this.$nextTick(function () {
                        location.reload();
                    });
                })
                .catch((err) => {
                    Utils.toast.error(err.response != null ? err.response.data.error_description : 'Error');
                    this.confimPasswordModalInstance.loading = false;
                });
        },
        identityProviderLogin(sessionRequest) {
            this.loading = true;
            sessionRequest.then((identityProviderRequestResponse) => {
                window.open(identityProviderRequestResponse.RedirectURL, '_blank');
                this.$store
                    .dispatch('account/login', {
                        identity_provider_session_id: identityProviderRequestResponse.SessionID,
                        impersonated_user_login: this.selectedUserDelegation.login
                    })
                    .then((resp) => {
                        this.confimPasswordModalInstance.loading = false;
                        this.confimPasswordModalInstance.hide();
                        window.getApp.$emit('APP_LOGIN_SUCCESS');
                        this.$router.push('/');
                        this.$nextTick(function () {
                            location.reload();
                        });
                    })
                    .catch((err) => {
                        if (
                            err.response &&
                            err.response.data &&
                            err.response.data.error &&
                            err.response.data.error.includes('FuturaeActivationQRCodeURL')
                        ) {
                            this.twoFactorAuthenticationEnroll(
                                err.response.data.error.replace(
                                    'FuturaeActivationQRCodeURL: ',
                                    ''
                                )
                            );
                        }
                        this.confimPasswordModalInstance.loading = false;
                    });
            });
        },
        entraidLogin() {
            const sessionRequest = EntraIdService.EntraIdRequest();
            this.identityProviderLogin(sessionRequest);
        },
        samlLogin() {
            const sessionRequest = UserService.samlRequest(this.$route.params.organization_id);
            this.identityProviderLogin(sessionRequest);
        },
        openModalConfirmPassword(delegation) {
            this.selectedUserDelegation = delegation;
            this.confimPasswordModalInstance.new();
        },
    }
};
</script>

<style>
.v-toolbar__content {
  padding-left: 2px !important;
}
</style>
